// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"73":"a31d3893","796":"dbda9be3"}[chunkId] + ".chunk.js";
};